<script>
import TemplatesPicker from './TemplatesPicker.vue';
import WhatsAppTemplateReply from './WhatsAppTemplateReply.vue';
export default {
  components: {
    TemplatesPicker,
    WhatsAppTemplateReply,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inboxId: {
      type: Number,
      default: undefined,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
    currentUser: {
      type: Object,
      default: () => ({}),
    },
    inboxName: {
      type: String,
      default: '',
    },
    accountName: {
      type: String,
      default: '',
    },
    initialTemplate: {
      type: Object,
      default: null,
    },
  },
  emits: ['onSend', 'cancel', 'update:show'],
  data() {
    return {
      selectedWaTemplate: null,
    };
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    modalEyebrow() {
      return 'TALKVIA • WHATSAPP';
    },
    modalHeaderContent() {
      return this.selectedWaTemplate
        ? this.$t('WHATSAPP_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
            templateName: this.selectedWaTemplate.name,
          })
        : this.$t('WHATSAPP_TEMPLATES.MODAL.SUBTITLE');
    },
    hasWhatsappTemplates() {
      const templates = this.$store.getters[
        'inboxes/getFilteredWhatsAppTemplates'
      ](this.inboxId);
      return Array.isArray(templates) && templates.length > 0;
    },
    modalSize() {
      // With templates, both steps use the full viewport height; the empty state stays compact.
      return this.selectedWaTemplate || this.hasWhatsappTemplates
        ? 'modal-whatsapp-template-picker'
        : 'modal-whatsapp-template';
    },
  },
  watch: {
    show(value) {
      if (value) this.selectedWaTemplate = this.initialTemplate;
    },
  },
  methods: {
    pickTemplate(template) {
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.selectedWaTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('onSend', message);
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <woot-modal v-model:show="localShow" :on-close="onClose" :size="modalSize">
    <div class="template-modal-header">
      <span class="template-modal-header__icon">
        <span class="i-lucide-layout-template size-5" />
      </span>
      <div class="min-w-0">
        <p class="mb-0 text-[10px] font-bold tracking-wider text-n-brand">
          {{ modalEyebrow }}
        </p>
        <h2 class="mb-0 mt-0.5 text-lg font-semibold text-n-slate-12">
          {{ $t('WHATSAPP_TEMPLATES.MODAL.TITLE') }}
        </h2>
        <p class="mb-0 mt-1 text-sm text-n-slate-10">
          {{ modalHeaderContent }}
        </p>
      </div>
    </div>
    <div
      class="modal-content"
      :class="{
        'modal-content-scroll': selectedWaTemplate,
        'modal-content-picker': !selectedWaTemplate,
        'modal-content-picker--empty':
          !selectedWaTemplate && !hasWhatsappTemplates,
      }"
    >
      <TemplatesPicker
        v-if="!selectedWaTemplate"
        :inbox-id="inboxId"
        @on-select="pickTemplate"
      />
      <WhatsAppTemplateReply
        v-else
        :template="selectedWaTemplate"
        :contact="contact"
        :current-user="currentUser"
        :inbox-name="inboxName"
        :account-name="accountName"
        @reset-template="onResetTemplate"
        @send-message="onSendMessage"
      />
    </div>
  </woot-modal>
</template>

<style scoped>
.template-modal-header {
  @apply flex shrink-0 items-center gap-3 border-b border-n-weak bg-n-brand/5 px-6 py-5;
}

.template-modal-header__icon {
  @apply grid size-11 shrink-0 place-items-center rounded-2xl bg-n-brand text-white shadow-sm shadow-n-brand/25;
}

:deep(.modal-container) {
  border-radius: 1rem !important;
}

.modal-content {
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
  padding: 1rem 1.5rem 1.5rem;
}

.modal-content-picker {
  height: auto;
  overflow: hidden;
}

.modal-content-picker--empty {
  height: auto;
}

.modal-content-scroll {
  overflow-y: auto;
  overscroll-behavior: contain;
}

@media (max-width: 48rem) {
  .modal-content {
    padding: 1rem;
  }
}
</style>
